// @ts-ignore
import React from "react";

import FeatureGates from "@atlassian/feature-gate-js-client";

import { IntercomProvider } from "@/libraries/intercom/src";

import { HomePageTemplate } from "../templates/home-page/src/index";

export const HomePage = () => {
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-home"
    );

    return (
        <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
            <HomePageTemplate />
        </IntercomProvider>
    );
};
